import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  learners: 'Learners',
  groups: 'Groups',
  newGroup: 'New group',
  createGroup: 'Create group',
  editGroup: 'Edit group',
  groupName: 'Name',
  groupNamePlaceholder: 'e.g. New Starters',
  groupDescription: 'Description',
  groupDescriptionPlaceholder: 'Group description',
  columnName: 'Name',
  columnDescription: 'Description',
  columnMembers: 'Members',
  columnActions: 'Actions',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  manageMembers: 'Manage members',
  deleteGroupConfirmation:
    'This group will be removed. The learners in it stay in the workspace.',
  membersModalTitle: (name: string) => `Members of ${name}`,
  membersModalSubtitle: 'Add or remove learners in this group',
  membersTab: 'Members',
  addLearners: 'Add learners',
  addSelected: 'Add',
  removeSelected: 'Remove',
  close: 'Close',
  emptyGroupsTitle: 'No groups yet',
  emptyGroupsText:
    'Groups let you enroll a whole team into a course in one action.',
  emptyMembersTitle: 'No learners in this group yet',
  emptyMembersText: 'Add learners from your workspace to get started.',
  emptyCandidatesTitle: 'Everyone is already here',
  emptyCandidatesText:
    'All active learners of this workspace are in the group.',
  cantFindGroups: 'No groups match your search',
  cantFindLearners: 'No learners match your search',
  membersCount: (count: number) =>
    `${count} ${count === 1 ? 'member' : 'members'}`,
  learnersCount: (count: number) =>
    `${count} ${count === 1 ? 'learner' : 'learners'}`,
  selectedCount: (count: number) => `${count} selected`,
  groupCreated: 'Group created',
  groupUpdated: 'Group updated',
  groupDeleted: 'Group deleted',
  membersAdded: 'Learners added to the group',
  membersRemoved: 'Learners removed from the group',
  groupsEnrolled: (count: number) =>
    count === 1 ? 'Group enrolled' : `${count} groups enrolled`,
};

const welsh = {
  learners: 'Dysgwyr',
  groups: 'Grwpiau',
  newGroup: 'Grŵp newydd',
  createGroup: 'Crëwch grŵp',
  editGroup: 'Golygwch y grŵp',
  groupName: 'Enw',
  groupNamePlaceholder: 'e.e. Dechreuwyr Newydd',
  groupDescription: 'Disgrifiad',
  groupDescriptionPlaceholder: 'Disgrifiad y grŵp',
  columnName: 'Enw',
  columnDescription: 'Disgrifiad',
  columnMembers: 'Aelodau',
  columnActions: 'Gweithredoedd',
  save: 'Cadw',
  cancel: 'Canslo',
  edit: 'Golygu',
  delete: 'Dileu',
  manageMembers: 'Rheolwch yr aelodau',
  deleteGroupConfirmation:
    'Bydd y grŵp hwn yn cael ei dynnu. Mae’r dysgwyr ynddo yn aros yn y gweithle.',
  membersModalTitle: (name: string) => `Aelodau ${name}`,
  membersModalSubtitle: 'Ychwanegwch neu tynnwch ddysgwyr yn y grŵp hwn',
  membersTab: 'Aelodau',
  addLearners: 'Ychwanegwch ddysgwyr',
  addSelected: 'Ychwanegwch',
  removeSelected: 'Tynnwch',
  close: 'Cau',
  emptyGroupsTitle: 'Dim grwpiau eto',
  emptyGroupsText:
    'Mae grwpiau’n gadael i chi gofrestru tîm cyfan ar gwrs mewn un weithred.',
  emptyMembersTitle: 'Dim dysgwyr yn y grŵp hwn eto',
  emptyMembersText: 'Ychwanegwch ddysgwyr o’ch gweithle i ddechrau.',
  emptyCandidatesTitle: 'Mae pawb yma’n barod',
  emptyCandidatesText:
    'Mae holl ddysgwyr gweithredol y gweithle hwn yn y grŵp.',
  cantFindGroups: 'Nid oes grwpiau’n cyfateb i’ch chwiliad',
  cantFindLearners: 'Nid oes dysgwyr yn cyfateb i’ch chwiliad',
  membersCount: (count: number) =>
    `${count} ${count === 1 ? 'aelod' : 'aelodau'}`,
  learnersCount: (count: number) =>
    `${count} ${count === 1 ? 'dysgwr' : 'dysgwyr'}`,
  selectedCount: (count: number) => `${count} wedi’u dewis`,
  groupCreated: 'Grŵp wedi’i greu',
  groupUpdated: 'Grŵp wedi’i ddiweddaru',
  groupDeleted: 'Grŵp wedi’i ddileu',
  membersAdded: 'Dysgwyr wedi’u hychwanegu at y grŵp',
  membersRemoved: 'Dysgwyr wedi’u tynnu o’r grŵp',
  groupsEnrolled: (count: number) =>
    count === 1 ? 'Grŵp wedi’i gofrestru' : `${count} grŵp wedi’u cofrestru`,
};

export const learnerGroupsText = getLocalizationBasedOnLang(english, welsh);
